(function () {
  function showPanel(root, key) {
    var tabs = root.querySelectorAll('[data-tabbed-steps-tab]');
    var panels = root.querySelectorAll('[data-tabbed-steps-panel]');

    tabs.forEach(function (tab) {
      var isActive = tab.dataset.tabbedStepsTab === key;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    panels.forEach(function (panel) {
      var isActive = panel.dataset.tabbedStepsPanel === key;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });
  }

  function initSection(root) {
    if (!root || root.dataset.tabbedStepsInitialized === 'true') return;
    root.dataset.tabbedStepsInitialized = 'true';

    var tabs = root.querySelectorAll('[data-tabbed-steps-tab]');
    if (!tabs.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        showPanel(root, tab.dataset.tabbedStepsTab);
      });
    });

    var activeTab = root.querySelector('[data-tabbed-steps-tab].is-active');
    var initialKey = activeTab
      ? activeTab.dataset.tabbedStepsTab
      : tabs[0].dataset.tabbedStepsTab;

    showPanel(root, initialKey);
  }

  function initAll() {
    document
      .querySelectorAll('[data-section-name="tabbed-steps"]')
      .forEach(initSection);
  }

  document.addEventListener('DOMContentLoaded', initAll);

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-section-name="tabbed-steps"]');
    if (root) initSection(root);
  });

  document.addEventListener('shopify:section:select', function (event) {
    var root = event.target.querySelector('[data-section-name="tabbed-steps"]');
    if (root) initSection(root);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var block = event.target;
    var root = block.closest('[data-section-name="tabbed-steps"]');
    if (!root) return;

    initSection(root);

    var panel = block.closest('[data-tabbed-steps-panel]');
    if (!panel) return;

    showPanel(root, panel.dataset.tabbedStepsPanel);
  });
})();